

import "./MyAi.css";
import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";

const MyAi = ({dark}) => {
  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text: "Hello 👋 I'm your AI assistant. Ask me anything."
    }
  ]);

  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);

  const messagesEndRef = useRef(null);

  const suggestions = [
    "Latest football news",
    "Top scorers this season",
    "Who won the Champions League?",
    "Today's matches"
  ];

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth"
    });
  }, [messages, typing]);

  const generateReply = (text) => {
    const lower = text.toLowerCase();

    if (lower.includes("news")) {
      return "📰 Here are the latest football headlines and transfer stories.";
    }

    if (lower.includes("match")) {
      return "⚽ Today's matches include Premier League and Champions League fixtures.";
    }

    if (
      lower.includes("top scorer") ||
      lower.includes("scorer")
    ) {
      return "🥅 Haaland, Mbappé and Kane are among the top scorers this season.";
    }

    if (
      lower.includes("champions league")
    ) {
      return "🏆 Real Madrid won the latest UEFA Champions League.";
    }

    return "🤖 I received your message successfully.";
  };

  const sendMessage = async (
    customText = null
  ) => {
    const text = customText || input;

    if (!text.trim()) return;

    const userMessage = {
      sender: "user",
      text
    };

    setMessages((prev) => [
      ...prev,
      userMessage
    ]);

    setInput("");
    setTyping(true);

    setTimeout(() => {
      const botReply = {
        sender: "bot",
        text: generateReply(text)
      };

      setMessages((prev) => [
        ...prev,
        botReply
      ]);

      setTyping(false);
    }, 1200);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      sendMessage();
    }
  };

  return (
    <div className={`ai-page ${dark ? "dark" : "light"}`}>
      <Helmet>
        <title>FadaSports AI Assistant - Sports Questions & Answers</title>
        <meta name="description" content="Chat with FadaSports AI Assistant. Ask questions about football, teams, players, match statistics, and get instant sports insights and answers." />
        <meta name="keywords" content="AI assistant, sports AI, football questions, sports chat, match stats, player stats" />
        <meta name="author" content="FadaSports" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="FadaSports AI Assistant" />
        <meta property="og:description" content="Chat with our AI assistant about football, teams, players, and sports statistics." />
        <meta property="og:image" content="https://fadasports.com/static/media/mobilelogo.d0257d49e02d3094cce0.png" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="FadaSports" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@FadaSports" />
      </Helmet>
      <div className="ai-container">

        <div className="ai-header">
          <div className="ai-status"></div>

          <div>
            <h2>Fada AI</h2>
            <p>Online Assistant</p>
          </div>
        </div>

        <div className="ai-messages">
          {messages.length <= 1 && (
            <div className="ai-suggestions">
              {suggestions.map((item, i) => (
                <button
                  key={i}
                  onClick={() =>
                    sendMessage(item)
                  }
                >
                  {item}
                </button>
              ))}
            </div>
          )}

          {messages.map((msg, i) => (
            <div
              key={i}
              className={`message ${msg.sender}`}
            >
              <p>{msg.text}</p>
            </div>
          ))}

          {typing && (
            <div className="typing">
              <span></span>
              <span></span>
              <span></span>
            </div>
          )}

          <div ref={messagesEndRef}></div>
        </div>

        <div className="ai-input">
          <input
            type="text"
            placeholder="Ask anything..."
            value={input}
            onChange={(e) =>
              setInput(e.target.value)
            }
            onKeyDown={handleKeyDown}
          />

          <button
            onClick={() => sendMessage()}
          >
            Send
          </button>
        </div>
      </div>
    </div>
  );
};

export default MyAi;